<template>
  <div>
    <v-data-table
      v-model="selectedStudents"
      :headers="headers"
      :items="students"
      :server-items-length="studentCount"
      item-key="id"
      showSelect
      :options.sync="tableOptions"
      :footer-props="tableFooterOptions"
      :loading="loading"
      loading-text="Đang Tải"
    >
      <template #top>
        <div
          class="d-flex align-center justify-space-between px-6 py-4"
          v-if="isSelectAllStudents || (selectedStudents && selectedStudents.length)"
        >
          <div class="d-flex flex-column">
            <span>
              <v-checkbox
                class="pa-0 ma-0 mb-2"
                v-model="isSelectAllStudents"
                label="Chọn tất cả học sinh"
                hide-details
                :disabled="loading"
                @change="onSelectAllStudentsChange"
              ></v-checkbox>
            </span>
            <span>
              {{ 'Đã chọn ' + selectedStudents.length + ' học sinh' }}
            </span>
          </div>
          <v-btn small color="primary" @click="onActivateAppClick" :loading="loading">Kích hoạt APP</v-btn>
        </div>
      </template>
      <!-- Học sinh -->
      <template #item.name="{ item }">
        <CardStudentName :student="item" link />
      </template>
      <!-- Ngày sinh -->
      <template #item.dob="{ item }">
        <span>{{ item.dob | ddmmyyyy }}</span>
      </template>
      <!-- Lớp -->
      <template #item.classes="{ item }">
        <router-link style="text-decoration: none" :to="'/class/' + (item.currentClass && item.currentClass.id)">
          <span v-if="item.currentClass">{{ item.currentClass && item.currentClass.title }}</span>
        </router-link>
      </template>
      <!-- Hình thức sử dụng -->
      <template #item.senderMethod="{ item }">
        <div class="d-flex align-center">
          {{ item | getNotificationMethod }}
          <div v-if="hasMobileToken(item)">
            <v-tooltip max-width="250px" bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" class="d-inline-block text-truncate" style="max-width: 150px">
                  <v-icon color="success">mdi-check</v-icon>
                </div>
              </template>
              <span>Đã đăng nhập</span>
            </v-tooltip>
          </div>
        </div>
      </template>
      <!-- Số điện thoại đăng ký -->
      <template #item.phone="{ item }">
        <v-tooltip max-width="250px" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="d-inline-block text-truncate" style="max-width: 150px">
              {{ item | getContactBookPhones }}
            </div>
          </template>
          <span>{{ item | getContactBookPhones }}</span>
        </v-tooltip>
      </template>
      <!-- Trạng thái -->
      <template #item.status="{ item }">
        <v-chip :color="item | getContactBookStatusColor" small class="white--text">
          {{ item | getContactBookStatus }}
        </v-chip>
      </template>
      <!-- Thao tác -->
      <template #item.action="{ item }">
        <ContactBookListActions :item="item" @contactBookUpdated="contactBookUpdated" />
      </template>
    </v-data-table>
    <ActiveAppConfirmDialog
      ref="active-app-confirm-dialog"
      :students="selectedStudents"
      @done="searchStudents(studentSearchParams)"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { isEmpty } from 'lodash'
import utils from '@/plugins/utils'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import ContactBookListActions from '@/modules/contactBook/ContactBookListActions.vue'
import ActiveAppConfirmDialog from '@/modules/contactBook/ActiveAppConfirmDialog.vue'

const defaultHeaders = [
  {
    text: 'Học sinh',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Ngày sinh',
    value: 'dob',
    align: 'left',
    sortable: false,
    show: true
  },
  { text: 'Lớp', value: 'classes', align: 'left', sortable: false, show: true },
  {
    text: 'Hình thức sử dụng',
    value: 'senderMethod',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'SĐT đăng ký',
    value: 'phone',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Trạng thái',
    value: 'status',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Thao tác',
    value: 'action',
    align: 'left',
    sortable: false,
    show: true
  }
]
export default {
  components: {
    CardStudentName,
    ContactBookListActions,
    ActiveAppConfirmDialog
  },
  props: {
    customHeaders: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      headers: isEmpty(this.customHeaders) ? defaultHeaders : this.customHeaders,
      tableOptions: {
        page: 1,
        itemsPerPage: 5
      },
      studentSearchParams: {},
      studentCount: 0,
      selectedStudents: [],
      isSelectAllStudents: false,
      loading: false
    }
  },
  computed: {
    ...mapState('students', ['students']),
    tableFooterOptions() {
      let footerOptions = {
        'items-per-page-text': 'Học sinh mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': this.tableOptions.itemsPerPage,
        'page-text': utils.paginationText(this.tableOptions, this.studentCount)
      }
      if (this.studentCount > 100) {
        footerOptions['items-per-page-options'] = [5, 10, 15]
      }
      return footerOptions
    }
  },
  methods: {
    ...mapActions('students', ['getOneStudent', 'getManyStudents', 'getStudentCount']),
    async searchStudents(studentFilters) {
      this.loading = true
      // New filter
      if (studentFilters) {
        this.selectedStudents = []
        this.isSelectAllStudents = false
        this.getStudentCount(studentFilters)
          .then(response => {
            this.studentCount = response
          })
          .catch(error => {
            this.$alert.error('Không lấy được số lượng học sinh. Lỗi : ', error)
            console.error(error)
          })
        this.tableOptions.page = 1
        this.studentSearchParams = { ...studentFilters, ...this.pageSetting() }
      } else {
        this.studentSearchParams = { ...this.studentSearchParams, ...this.pageSetting() }
      }
      try {
        await this.getManyStudents({ searchParams: this.studentSearchParams })
      } catch (error) {
        this.$alert.error('Không lấy được danh sách học sinh. Lỗi : ', error)
        console.error(error)
      }
      this.loading = false
    },
    pageSetting() {
      return {
        _start: (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage,
        _limit: this.tableOptions.itemsPerPage
      }
    },
    async onSelectAllStudentsChange() {
      if (this.isSelectAllStudents) {
        this.loading = true
        try {
          const response = await this.getManyStudents({
            searchParams: { ...this.studentSearchParams, _start: 0, _limit: -1 },
            disableSave: true
          })
          this.selectedStudents = response
        } catch (error) {
          this.$alert.error('Không lấy được danh sách học sinh. Lỗi : ', error)
          console.error(error)
        }
        this.loading = false
      } else {
        this.selectedStudents = []
      }
    },
    onActivateAppClick() {
      this.$refs['active-app-confirm-dialog'].dialog = true
    },
    contactBookUpdated(student) {
      this.selectedStudents = this.selectedStudents.filter(s => s.id !== student.id)
      try {
        this.getOneStudent(student)
      } catch (error) {
        console.error(error)
      }
    },
    hasMobileToken(item) {
      if (item.contactBook && item.contactBook.isApp && (item.fcmAndroid || item.fcmIos)) {
        let tokens = []
        if (item.fcmAndroid) {
          const androidTokens = item.fcmAndroid.split(';')
          androidTokens.map(token => {
            if (token) tokens.push(token)
          })
        }
        if (item.fcmIos) {
          const iosTokens = item.fcmIos.split(';')
          iosTokens.map(token => {
            if (token) tokens.push(token)
          })
        }

        tokens = [...new Set(tokens)]
        return tokens.length > 0
      }
      return false
    }
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.searchStudents()
        }
      },
      deep: true
    }
  }
}
</script>
